import { useState, useEffect } from 'react';
import { Tenant } from '../types/tenant';
import { getCurrentTenant } from '../services/tenantService';
import { useAuth } from '../context/AuthContext';


export const useCurrentTenant = () => {
    const [tenant, setTenant] = useState<Tenant | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const { isAuthenticated, token, logout } = useAuth();

    const fetchCurrentTenant = async () => {
        if (!isAuthenticated || !token) {
            setLoading(false);
            return;
        }
        try {
            setLoading(true);
            const tenantData = await getCurrentTenant();
            setTenant(tenantData);
            setError(null);
        } catch (err: any) {
            // Registrar el error para diagnóstico
            console.error('Error al obtener información del tenant:', err);
            setError(err.message || 'Error al obtener información del tenant');
            setTenant(null);
            // Si el error es de autenticación, redirigir a login
            if (err?.response?.status === 401 || err?.response?.status === 403) {
                if (logout) {
                    logout();
                }
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCurrentTenant();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAuthenticated, token]);

    // Permitir reintentar la carga del tenant
    const retry = () => {
        fetchCurrentTenant();
    };

    return { tenant, loading, error, retry };
};
